import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import { Link } from "react-router-dom"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  FormGroup,
  Input,
  Label,
  Collapse,
} from "reactstrap"
import Select from "react-select"
import { AvForm, AvField } from "availity-reactstrap-validation"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// import "./datatables.scss"
import CustomTable from "components/Table/Table"

export const CandidateList = () => {
  // ---------------------Collapse Start-------------------------
  const [faq1, setFaq1] = useState(false)
  // ---------------------Collapse End-------------------------

  // const [Candidate_Modal, setCandidate_Modal] = useState(false)

  // function removeBodyCss() {
  //   document.body.classList.add("no_padding")
  // }

  // function AddCandidate_Modal() {
  //   setCandidate_Modal(!Candidate_Modal)
  //   removeBodyCss()
  // }

  const [selectedGroup, setselectedGroup] = useState(null)
  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    {
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
    },
  ]

  const [totalSize, setTotalSize] = useState(3)

  const data = {
    columns: [
      {
        text: "First Name",
        dataField: "FirstName",
        style: { width: "10%" },
      },
      {
        text: "Last Name",
        dataField: "LastName",
        style: { width: "10%" },
      },
      {
        text: "Gender",
        dataField: "Gender",
        style: { width: "10%" },
      },
      {
        text: "Mobile Number",
        dataField: "MobileNumber",
        style: { width: "14%" },
      },
      {
        text: "Email Id",
        dataField: "EmailId",
        style: { width: "18%" },
      },
      {
        text: "Status",
        dataField: "Status",
        style: { width: "10%" },
      },
    ],
    rows: [
      {
        FirstName: "Nilesh",
        LastName: "Soni",
        Gender: "Male",
        MobileNumber: "+91 9601615060",
        EmailId: "info@nilesh.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <Link
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              to="./add-candidate"
            >
              <i class="fa fa-edit"></i>
            </Link>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        FirstName: "Nishit",
        LastName: "Kachiya",
        Gender: "Male",
        MobileNumber: "+91 9601615060",
        EmailId: "info@nishit.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <Link
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              to="./add-candidate"
            >
              <i class="fa fa-edit"></i>
            </Link>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
      {
        FirstName: "Bhargav",
        LastName: "Kondhiya",
        Gender: "Male",
        MobileNumber: "+91 9601615060",
        EmailId: "info@bhargav.com",
        Status: (
          <>
            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Active / Inactive"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-bullseye"></i>
            </button>

            <Link
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              style={{ width: "25px", height: "25px", padding: "0px" }}
              title="Edit"
              to="./add-candidate"
            >
              <i class="fa fa-edit"></i>
            </Link>

            <button
              className="btn btn-secondary waves-effect waves-light btn btn-secondary mx-1"
              title="Delete"
              style={{ width: "25px", height: "25px", padding: "0px" }}
            >
              <i className="fas fa-trash-alt" style={{ color: "red" }}></i>
            </button>
          </>
        ),
      },
    ],
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Candidate List | Matrimonial Admin</title>
        </MetaTags>
        <div className="container-fluid">
          <Row>
            <Breadcrumbs
              maintitle="Dashboard"
              title="Master"
              breadcrumbItem="Candidate List"
            />
            <Col sm={6}>
              <div className="float-end d-none d-md-block pt-2">
                <Link
                  color="primary"
                  className="btn btn-primary waves-effect waves-light mt-4"
                  to="./add-candidate"
                >
                  Add Candidate
                </Link>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="accordion mb-3" id="accordionExample">
                <div className="accordion-item">
                  <div className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button font-size-15 faq"
                      style={{
                        backgroundColor: "rgb(164, 229, 207)",
                        height: "40px",
                        color: "#000",
                      }}
                      type="button"
                      onClick={() => {
                        setFaq1(!faq1)
                      }}
                    >
                      <i class="fas fa-filter"></i> &nbsp;Filter Candidate List
                    </button>
                  </div>
                  <Collapse isOpen={faq1} className="accordion-collapse">
                    <div className="accordion-body">
                      <Row>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Name</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              name="Name"
                              id="Name"
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Email Id</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              name="Email"
                              id="Email"
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Mobile Number</Label>
                            <Input
                              type="text"
                              maxLength="25"
                              onChange={e => {
                                placementchange(e)
                              }}
                              name="MobileNumber"
                              id="MobileNumber"
                            />
                          </div>
                        </Col>
                        <Col lg="3">
                          <div className="mb-3">
                            <Label>Status</Label>
                            <Select
                              value={selectedGroup}
                              onChange={() => {
                                handleSelectGroup()
                              }}
                              options={optionGroup}
                              classNamePrefix="select2-selection"
                            />
                          </div>
                        </Col>
                        <Col lg="12">
                          <div className="float-end d-none d-md-block pt-0">
                            <Button
                              color="primary"
                              className="btn btn-primary waves-effect waves-light mt-0"
                            >
                              Search
                            </Button>{' '}
                            <Button
                              color=""
                              className="btn btn-outline-primary mt-0"
                            >
                              Clear
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Collapse>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <MDBDataTable responsive bordered data={data} noBottomColumns/> */}
                  <CustomTable
                    keyField="candidateList"
                    columns={data.columns}
                    data={data.rows}
                    totalSize={totalSize}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* <Modal
        size="md"
        isOpen={Candidate_Modal}
        toggle={() => {
          AddCandidate_Modal()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">
            Candidate
          </h5>
          <button
            onClick={() => {
              AddCandidate_Modal()
            }}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <AvForm className="needs-validation">
            <Row>
              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="FirstName"
                    label="First Name"
                    placeholder="First Name"
                    type="text"
                    errorMessage="Enter First Name"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="FirstName"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    name="LastName"
                    label="Last Name"
                    placeholder="Last Name"
                    type="text"
                    errorMessage="Enter Last Name"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="LastName"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField type="select" name="Gender" label="Gender">
                    <option>Male</option>
                    <option>Female</option>
                  </AvField>
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    label="Mobile Number"
                    name="MobileNumber"
                    placeholder="Mobile Number"
                    type="text"
                    errorMessage="Enter Mobile Number"
                    className="form-control"
                    validate={{ required: { value: true } }}
                    id="MobileNumber"
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField
                    label="Email Id"
                    name="email"
                    placeholder="Enter Valid Email Id"
                    type="email"
                    errorMessage="Invalid Email Id"
                    validate={{
                      required: { value: true },
                      email: { value: true },
                    }}
                  />
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup className="mb-3">
                  <AvField type="select" name="Status" label="Status">
                    <option>Active</option>
                    <option>Inactive</option>
                  </AvField>
                </FormGroup>
              </Col>
            </Row>
            <Button color="primary" className="mt-3" type="submit">
              Submit
            </Button>{" "}
            <Button
              color="outline-primary"
              className="mt-3"
              onClick={() => {
                AddCandidate_Modal()
              }}
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </Button>
          </AvForm>
        </div>
      </Modal> */}
    </React.Fragment>
  )
}
